import { render } from "./Sidebar.vue?vue&type=template&id=e3b0b398&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=e3b0b398&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=e3b0b398&lang=css"
script.render = render
script.__scopeId = "data-v-e3b0b398"

export default script